<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Валюта</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <button @click="updateExchangeRate()" type="button" class="btn btn-white btn-icon-text my-2 mr-2">
            <i class="fe fe-refresh-cw mr-2"></i> Обновить курс валют
          </button>
          <router-link to="/currency/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Добавить валюту
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Список валют</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="currencyList" :fields="tableFields">
                <template #cell(is_main)="row" class="cursor-pointer">
                  <input type="radio" :checked="row.item.is_main" name="is_main" class="is_main" @change="updateMainCurrency(row.item.id)">
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`/currency/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="removeCurrency(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restCurrency(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="removeCurrency(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'Currency',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      currencyList: state => state.currency.currencyList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'is_main',
          label: 'По умолчанию',
          sortable: true
        },
        {
          key: 'name.' + this.$i18n.locale,
          label: 'Название',
          sortable: true
        },
        {
          key: 'code',
          label: 'Код',
          sortable: true
        },
        {
          key: 'symbol',
          label: 'Символ',
          sortable: true
        },
        {
          key: 'currency_rate',
          label: 'Курс валют',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Действие',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getCurrency({})
  },
  methods: {
    ...mapActions({
      getAllCurrency: 'currency/getAllCurrency',
      deleteCurrency: 'currency/deleteCurrency',
      updateCurrenciesExchangeRate: 'currency/updateCurrenciesExchangeRate',
      restoreCurrency: 'currency/restoreCurrency',
      updateCurrenciMainStatus: 'currency/updateCurrenciMainStatus'
    }),
    updateMainCurrency (id) {
      this.updateCurrenciMainStatus(id).then(() => {
        this.$toasted.success('Рубль is set main currency successfully!!').goAway(1500)
      })
    },
    updateExchangeRate () {
      this.updateCurrenciesExchangeRate().then(res => {
        this.$toasted.success('Successfully Updated Currency Exchange Rate!').goAway(1500)
        this.getCurrency({})
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    getCurrency (params) {
      this.getAllCurrency(params).then(res => {
        this.pagination = res.pagination
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    changePaginationPerPage (value) {
      this.getVideos({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getVideos({ page: page, count: this.paginationPerPage })
    },
    removeCurrency (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteCurrency({ id }).then(res => {
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restCurrency (id) {
      this.restoreCurrency({ id }).then(res => {
      })
    }
  }
}
</script>

<style>
  .is_main {
    transform: scale(1.5);
    -ms-transform: scale(1.5);
    -webkit-transform: scale(1.5);
    cursor: pointer;
  }
</style>
